<template>
  <div class="productBgBlock"
       v-if="limitedVariationEntriesOfThisGroupFromVariationGroupData.length > 0">
    <div>{{ variationGroup.variationGroupName + ' : ' + defaultValue }} </div>
    <div class="variationsBlock" :class="!variationEntriesMoreThan8 ? 'full-width-variations-block' : ''">
      <div class="variation-image-container">
        <div v-for="variationEntry in variationGroupHandler()"
             :key="variationEntry.variationId"
             class="variation-image"
             :class="getVariationImageStatus(defaultValue, variationEntry)"
             @mouseover="displayVariationName = variationEntry.variationName"
             @mouseleave="displayVariationName = ''"
        >
          <img v-if="variationEntry.variationDisplayValue"
               :src="`/files/product_variations/${variationEntry.variationDisplayValue}`"
               :alt="variationEntry.variationName"
               v-on:click="navigateToProduct(variationEntry.variationId)"
               class="img-fluid"
               width="100"
               height="100"
          >

          <img v-else
               :src="`/files/products/${getVariationProductsImage(variationEntry.variationId)}`"
               :alt="variationEntry.variationName"
               v-on:click="navigateToProduct(variationEntry.variationId)"
               class="img-fluid"
               width="100"
               height="100"
          >
          <div class="variation-tooltip" v-if="displayVariationName === variationEntry.variationName">
            {{ variationEntry.variationName }}
          </div>
        </div>
      </div>
      <div v-if="variationEntriesMoreThan8" class="see-more-btn" >
      <span @click="openModal">
        {{ t('see.more.variation.images.text') }} ({{ getVariationEntriesOfThisGroupFromVariationGroupData.length }})
      </span>
      </div>
    </div>
    <VariationModal v-show="showModal"
                    v-on:close-modal="closeModal"
                    :variation-group="variationGroup"
                    :default-value="defaultValue"
                    :current-variation-product-group-combo="currentVariationProductGroupCombo"
                    :variations="variationGroupHandler(true)"
                    :variation-product-group-combos="variationProductGroupCombos"
    />
  </div>
</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'
import VariationModal from './VariationModal'

export default {
  name: 'VariationImageSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      selected: null,
      showModal: false,
      displayVariationName: ''
    }
  },
  components: {
    VariationModal
  },
  methods: {
    getVariationOutOfStock (variation) {
      return variation.stock <= 0
    },
    getVariationImageStatus (defaultValue, variation) {
      const statusMap = [
        { condition: variation.alreadyExists === false, value: 'variation-image-disabled' },
        { condition: this.getVariationOutOfStock(variation), value: 'variation-image-out_of_stock' },
        { condition: defaultValue === variation.variationName, value: 'variation-image-current_product' }
      ]

      const match = statusMap.find(entry => entry.condition)
      return match ? match.value : ''
    },
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    shouldShowUniqueValuesFromImageVariationGroupAsDisabled () {
      return this.variationGroup.variationGroupId === 1
    },
    variationGroupHandler (isModal = false) {
      if (this.shouldShowUniqueValuesFromImageVariationGroupAsDisabled() && !isModal) {
        return this.getVariationUniqueVariationValuesOfThisGroupFromVariationGroupData.slice(0, 8)
      } else if (this.shouldShowUniqueValuesFromImageVariationGroupAsDisabled()) {
        return this.getVariationUniqueVariationValuesOfThisGroupFromVariationGroupData
      } else {
        return this.limitedVariationEntriesOfThisGroupFromVariationGroupData
      }
    }
  },
  computed: {
    variationEntriesMoreThan8 () {
      return this.getVariationEntriesOfThisGroupFromVariationGroupData.length > 8
    }
  }
}
</script>

<style lang="scss" scoped>
.variation-tooltip {
  width: clamp(100%, 10vw, 150%);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-size:13px;
}

.variation-image {
  display: grid;
  align-items: center;
  justify-items: center;

  img {
    width: 70px;
    height: 70px;
    object-fit: contain;
  }
}

.variationsBlock {
  display: grid;
  width: 100%;
  margin-bottom:15px;
  @media screen and (max-width:575px){
    padding-left:0;
    padding-right:0
  }
}

.native_slider-lg {
  grid-auto-columns: 20%;
  width: 80%;
  padding-top: 20px;
  grid-gap: 15px;
  padding-bottom:40px;
  padding-left:15px;
  @media screen and (max-width:575px){
    width:100%;
    grid-auto-columns: 16.66667%;
  }
  @media screen and (max-width:400px){
    grid-auto-columns: 23%
  }
}

.full-width {
  width: 100%;
}

.variation-image-current_product{
  position:relative;
  border:0;
  &:before{
    z-index:1;
    width:110%;
    height:110%;
    border:2px solid var(--prime2);
    position: absolute;
    content:"";
    left:-5%;
    top:-5%;
    border-radius:5px
  }
}

.variation-image-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 15px;
}

.variationsBlock {
  display: grid;
  width: 100%;
  margin: 15px 0 15px 0;
  grid-template-columns: auto 20%;
  grid-gap: 15px;
  @media screen and (max-width:1200px){
    grid-template-columns: 100%;
  }
}

.full-width-variations-block {
  grid-template-columns: 100%;
}

.see-more-btn {
  display: grid;
  align-items: end;
  justify-content: center;
  font-size: clamp(11px, 2.5vw, 13px);
  span:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
